{
  "COMMON": {
    "CANCEL": "Cancelar",
    "CLEAN": "Limpiar",
    "OK": "OK",
    "NEXT": "Siguiente",
    "BACK": "Atrás",
    "SKIP": "Omitir",
    "CONTINUE": "Continuar",
    "NEW": "Nuevo",
    "TRUE": "Verdadero",
    "FALSE": "Falso",
    "FILTERS": "Filtros",
    "VERSION": "Versión",
    "ACTIVE": "Activo",
    "INACTIVE": "Inactivo",
    "SAVE": "Guardar",
    "DELETE": "Eliminar",
    "CONFIRM_DELETE": "Confirmar eliminación",
    "CONFIRM_DELETE_BODY": "¿Estás seguro de eliminar a {{name}}?",
    "DELETE_SUCCESS": "Eliminado correctamente",
    "CREATE_SUCCESS": "Creado correctamente",
    "UPDATE_SUCCESS": "Actualizado correctamente",
    "LOADING": "Cargando…",
    "SECURITY": "Seguridad",
    "SEARCH": "Buscar",
    "NAME": "Nombre",
    "ADD": "Agregar",
    "UPDATE": "Actualizar",
    "EDITING": "Editando: {{name}}"
  },
  "IMAGE_VIEWER": {
    "ZOOM_IN": "Acercar",
    "ZOOM_OUT": "Alejar",
    "FIT": "Ajustar",
    "CLOSE": "Cerrar",
    "HINT": "Pellizca o usa la rueda para acercar · toca dos veces para ampliar ahí"
  },
  "APP": {
    "EXIT_CONFIRM": "¿Desea salir de la APP?"
  },
  "ERROR": {
    "HEADER": "Alerta",
    "UNEXPECTED": "Error inesperado",
    "STATUS": "Status: {{status}}",
    "NETWORK": "Error de red. Verifica tu conexión."
  },
  "UPDATE": {
    "READY": "Hay una nueva versión disponible",
    "RELOAD": "Actualizar ahora",
    "MODAL_TITLE": "Actualización disponible",
    "NEW_VERSION": "Una nueva versión de la app está lista. Recarga para obtener las últimas funciones y mejoras.",
    "LATER": "Después",
    "UP_TO_DATE": "Ya tienes la última versión",
    "UNAVAILABLE": "Las actualizaciones automáticas no están disponibles en este entorno"
  },
  "NETWORK": {
    "OFFLINE": "Sin conexión — trabajando en modo offline",
    "ONLINE": "Conexión restablecida",
    "SYNCED": "Datos locales sincronizados correctamente",
    "SYNCED_PARTIAL": "Algunos cambios no se pudieron sincronizar — se reintentará al reconectar",
    "SAVED_OFFLINE": "Guardado localmente — se sincronizará al reconectar",
    "NO_CACHED_PRODUCTS": "No hay productos disponibles sin conexión. Conéctate a internet para cargar el catálogo de productos."
  },
  "CONFIG": {
    "INTRO": "La <b>APP</b> donde podrás gestionar tu <u>Tienda Perfecta</u> en tiempo real.",
    "PERFECT_STORE": {
      "TITLE": "¿Qué es una Tienda Perfecta?",
      "BODY": "<b>Tienda Perfecta</b> o <b>Perfect Store</b> es una estrategia de trade marketing que busca la excelencia en el punto de venta (PDV) para impulsar ventas"
    },
    "PREFERENCES": {
      "TITLE": "Hazla tuya",
      "BODY": "Elige tu idioma y apariencia. Podrás cambiarlo cuando quieras desde Configuración.",
      "LANGUAGE": "Idioma",
      "DARK_MODE": "Modo oscuro"
    },
    "READY": {
      "TITLE": "¿Todo listo para empezar?",
      "BODY": "Todo está listo. Puedes ajustar tus preferencias cuando quieras desde Configuración.",
      "START": "Iniciar"
    },
    "APPEARANCE": {
      "TITLE": "Apariencia",
      "BODY": "Cambia entre modo claro y oscuro."
    },
    "ERROR": {
      "HEADER": "Alerta",
      "SUBHEADER": "Código incorrecto",
      "MESSAGE": "Error al obtener la configuración inicial. Revisa tu conexión y vuelve a intentarlo."
    }
  },
  "LOGIN": {
    "WELCOME": "Bienvenido",
    "SUBTITLE": "Inicia sesión para continuar",
    "USERNAME": "Usuario",
    "PASSWORD": "Contraseña",
    "SUBMIT": "Iniciar sesión",
    "FAILED_HEADER": "Error de inicio de sesión",
    "FAILED_MESSAGE": "Acceso denegado.",
    "ROLE_NOT_SUPPORTED": "Tu rol de usuario no tiene acceso a esta aplicación."
  },
  "MENU": {
    "TITLE": "Menú",
    "ITEMS": {
      "PRODUCTS": "Productos",
      "DASHBOARD": "Dashboard",
      "MARKETERS": "Mercaderistas",
      "ROUTES": "Rutas",
      "CHAINS": "Cadenas",
      "REPORTS": "Reportes",
      "PERFECT_STORE": "Tienda Perfecta"
    }
  },
  "POS": {
    "TITLE": "POS",
    "TOTAL": "Total",
    "TAXES": "Impuestos",
    "QTY": "Ctdad.",
    "DISCOUNT": "Desc.",
    "PRICE": "Precio"
  },
  "CUSTOMER": {
    "TITLE": "Clientes",
    "EMPTY_TITLE": "Sin clientes aún",
    "EMPTY_BODY": "Cuando registres clientes, aparecerán en esta lista."
  },
  "DASHBOARD": {
    "TITLE": "Dashboard",
    "SUMMARY_TITLE": "Resumen",
    "QUICK_ACTIONS_TITLE": "Acceso rápido",
    "CHECK_UPDATES": "Buscar actualizaciones",
    "KPI": {
      "COMPLETED": "Completadas",
      "PENDING_SYNC": "Pendientes de sincronizar",
      "AVG_VISIT_DURATION": "Duración promedio",
      "AVG_SYNC_TIME": "Tiempo de sincronización"
    },
    "CHARTS": {
      "TITLE": "Gráficos",
      "VISITS": "Visitas: planificadas vs realizadas",
      "PLANNED": "Planificadas",
      "COMPLETED": "Realizadas"
    },
    "ASSIGNMENTS": {
      "TITLE": "Mis asignaciones",
      "SYNC": "Sincronizar asignaciones",
      "SUMMARY": "{{routes}} rutas · {{pos}} puntos de venta",
      "POS_PER_ROUTE": "PDV por ruta",
      "POS_BY_DAY": "PDV a visitar por día",
      "EMPTY_TITLE": "Sin asignaciones",
      "EMPTY_BODY": "Usa 'Sincronizar' para descargar tus rutas y puntos de venta.",
      "ROUTE_POS_TREEMAP": "Árbol rutas · PDV",
      "TREEMAP_ROOT": "Todas las rutas",
      "TREEMAP_VISIT": "Frec. visita",
      "TODAY": "Rutas de hoy",
      "START_VISIT": "Empezar visita"
    },
    "SYNC_ALL": "Sincronizar todo",
    "VISIT_IN_PROGRESS": "Visita en curso",
    "CONTINUE_VISIT": "Continuar",
    "DAYS": {
      "MON": "Lun",
      "TUE": "Mar",
      "WED": "Mié",
      "THU": "Jue",
      "FRI": "Vie",
      "SAT": "Sáb"
    },
    "PERFECT_STORE": {
      "TITLE": "Tienda Perfecta"
    }
  },
  "MARKETER": {
    "TITLE": "Mercaderistas",
    "NEW_BUTTON": "Nuevo",
    "ACTIVE_HEADER": "Mercaderistas activos",
    "NEW_TITLE": "Nuevo Mercaderista",
    "EDIT_TITLE": "Editar Mercaderista",
    "EMPTY": "No hay mercaderistas registrados",
    "DUPLICATE_EMAIL": "Ya existe un mercaderista con este correo electrónico",
    "NOT_FOUND": "Mercaderista no encontrado.",
    "VALIDATION_ERROR": "Error de validación. Verifica los datos ingresados.",
    "IMAGE_FORMAT_ERROR": "Formato de imagen no soportado. Usa JPEG, PNG, GIF o WebP.",
    "IMAGE_SIZE_ERROR": "La imagen es demasiado grande. Selecciona una imagen más pequeña.",
    "LAST_LOGIN": "Último acceso",
    "FORM": {
      "NAME": "Nombre completo",
      "EMAIL": "Correo electrónico",
      "PASSWORD": "Contraseña",
      "PHONE": "Teléfono",
      "ACTIVE": "Activo",
      "IMAGE": "Agregar foto"
    }
  },
  "PAYMENT": {
    "TITLE": "Registrar pago",
    "EMPTY_TITLE": "Sin pagos registrados",
    "EMPTY_BODY": "Los pagos que registres se mostrarán en esta pantalla."
  },
  "PRODUCT": {
    "TITLE": "Catálogo de productos",
    "DETAIL_TITLE": "Producto",
    "MODIFY_FILTERS": "Modificar filtros",
    "NEW": "Nuevo producto",
    "EDIT_TITLE": "Editar producto",
    "EMPTY_TITLE": "Sin productos",
    "EMPTY_BODY": "Los productos que agregues se mostrarán en esta pantalla.",
    "SEARCH": "Buscar productos",
    "DOWNLOAD_TEMPLATE": "Descargar plantilla",
    "IMPORT": "Importar",
    "IMPORT_RESULT": "Importados: {{total}} total, {{created}} creados, {{updated}} actualizados, {{errors}} errores",
    "IMPORT_RESULT_HEADER": "Importación completada",
    "IMPORT_ERROR_ROW": "Fila {{row}}: {{message}}",
    "IMPORT_ERROR": "Error al importar. Verifica el formato del archivo e inténtalo de nuevo.",
    "IMPORT_DOWNLOAD_ERROR": "No se pudo descargar la plantilla. Inténtalo de nuevo.",
    "DELETE_CONFIRM_BODY": "¿Estás seguro de que deseas eliminar \"{{name}}\"?",
    "FIELDS": {
      "NAME": "Nombre",
      "SKU": "SKU",
      "INTERNAL_CODE": "Código interno",
      "CATEGORY": "Categoría",
      "SUBCATEGORY": "Subcategoría",
      "MANUFACTURER": "Fabricante",
      "BRAND": "Marca",
      "UNIT": "Unidad",
      "PACKAGING": "Tipo de envase",
      "IS_INTERNAL": "Marca propia (puntúa en Tienda Perfecta)",
      "INTERNAL": "Interno",
      "COMPETITION": "Competencia",
      "IMAGE": "Imagen del producto",
      "SELECT_IMAGE": "Seleccionar imagen",
      "REMOVE_IMAGE": "Quitar imagen",
      "NO_CATEGORIES_HINT": "No hay categorías disponibles — créalas primero"
    },
    "ERRORS": {
      "NOT_FOUND": "Producto no encontrado",
      "CONFLICT": "Conflicto: no se pudo guardar el producto",
      "VALIDATION": "Datos inválidos. Revisa los campos e inténtalo de nuevo.",
      "DELETE_CONFLICT": "Este producto no se puede eliminar porque tiene registros asociados.",
      "IMAGE_TYPE": "Tipo de imagen inválido. Usa JPEG, PNG o WebP.",
      "IMAGE_SIZE": "La imagen excede el tamaño máximo permitido (5 MB)."
    },
    "MANAGE": {
      "CATEGORIES": "Categorías",
      "SUBCATEGORIES": "Subcategorías",
      "MANUFACTURERS": "Fabricantes",
      "BRANDS": "Marcas",
      "UNITS": "Unidades",
      "PACKAGING": "Tipos de envase",
      "ADD": "Agregar nuevo"
    }
  },
  "FILTER": {
    "TITLE": "Modificar filtros",
    "NEW_FILTER": "Nuevo filtro",
    "FIELD": "Campo",
    "FIELDS": "Campos",
    "VALUE": "Valor",
    "NAME_IS": "{{field}} es {{value}}"
  },
  "REPORT": {
    "TITLE": "Reportes",
    "SELECT_REPORT": "Seleccionar reporte",
    "APPLY_FILTERS": "Aplicar filtros",
    "CLEAR_FILTERS": "Limpiar filtros",
    "NO_REPORTS": "No hay reportes disponibles",
    "LOAD_ERROR": "Error al cargar el reporte",
    "RETRY": "Reintentar",
    "EXPORTING": "Exportando reporte completo...",
    "REFRESH": "Actualizar",
    "YES": "Sí",
    "NO": "No",
    "ALL": "Todos",
    "DATE": "Fecha",
    "PRODUCT": "Producto",
    "SKU": "SKU",
    "CATEGORY": "Categoría",
    "MARKETER": "Mercaderista",
    "SALES_POINT": "Punto de Venta",
    "REGION": "Región",
    "CHANNEL": "Canal",
    "REVENUE": "Ingresos",
    "UNITS": "Unidades",
    "TARGET": "Meta",
    "COMPLIANCE": "Cumplimiento",
    "STATUS": "Estado",
    "VISIT_TYPE": "Tipo de Visita",
    "ADD_FILTER": "Agregar filtro",
    "FIELD": "Campo",
    "OPERATOR": "Operador",
    "VALUE": "Valor",
    "CONTAINS": "contiene",
    "EQUALS": "es igual a",
    "GREATER_THAN": "mayor que",
    "LESS_THAN": "menor que",
    "SHOWING": "Mostrando {{start}}-{{end}} de {{total}} resultados",
    "PREVIOUS": "Anterior",
    "NEXT": "Siguiente",
    "PER_PAGE": "por página",
    "FILTER_BY": "Filtrar por",
    "NO_RESULTS": "Ningún resultado coincide con tus filtros",
    "COLUMNS": "Columnas",
    "EXPORT": "Exportar",
    "EXPORT_CSV": "Exportar CSV",
    "EXPORT_EXCEL": "Exportar Excel",
    "EXPORT_PDF": "Exportar PDF",
 "EVIDENCE_TITLE": "Foto de evidencia",
    "COLUMN_KEYS": {
      "id": "ID",
      "visit_id": "ID Visita",
      "visit_start_date": "Fecha Inicio",
      "visit_end_date": "Fecha Fin",
      "visit_duration": "Duración",
      "visit_sync_duration": "Tiempo Sinc.",
      "visit_create_date": "Fecha Creación",
      "marketer_name": "Mercaderista",
      "marketer_email": "Email Mercaderista",
      "marketer_phone": "Teléfono Mercaderista",
      "pos_name": "Punto de Venta",
      "pos_address": "Dirección PDV",
      "chain_name": "Cadena",
      "region_name": "Región",
      "route_name": "Ruta",
      "availability": "Disponibilidad",
      "availability_label": "Disponibilidad",
      "product_name": "Producto",
      "product_sku": "SKU",
      "product_internal_code": "Código Interno",
      "product_category_name": "Categoría",
      "product_subcategory_name": "Subcategoría",
      "product_manufacturer_name": "Fabricante",
      "product_brand_name": "Marca",
      "product_unit_name": "Unidad",
      "product_packaging_type_name": "Empaque",
  "product_is_internal": "Marca Interna",
  "shelf_visibility_cm": "Visibilidad Anaquel (cm)",
  "product_visibility_cm": "Visibilidad Producto (cm)",
  "has_price": "Precio Visible",
  "price": "Precio",
  "has_discount_price": "Precio de Oferta",
  "discount_price": "Precio Oferta",
  "is_direct_block": "Bloque Directo",
  "is_shelf_level": "Nivel de Plancha",
  "has_competitor": "Competencia",
  "has_evidence_image": "Foto Evidencia",
  "evidence_image_url": "URL Foto",
  "name": "Mercaderista",
      "email": "Email",
      "phone": "Teléfono",
      "visits": "Visitas",
      "duration": "Duración Total",
      "avg_duration": "Duración Promedio",
      "products": "Productos Evaluados",
      "pos": "Puntos de Venta",
      "routes": "Rutas",
      "first_visit": "Primera Visita",
      "last_visit": "Última Visita",
      "marketer_id": "ID Mercaderista",
      "pos_id": "ID Punto de Venta",
      "chain_id": "ID Cadena",
      "region_id": "ID Región",
      "route_id": "ID Ruta",
      "version_name": "Ponderación",
      "evaluable": "Evaluable",
      "reason": "Motivo",
      "indicator_weight": "Peso del indicador",
      "score": "Nota Disponibilidad",
      "earned": "Puntos ganados",
      "lost": "Puntos perdidos",
      "ceiling": "Techo del PSS",
      "max_band_name": "Semáforo máximo",
      "max_band_color": "Color semáforo",
      "skus_expected": "SKU evaluados",
      "skus_registered": "SKU registrados",
      "visits_evaluable": "Visitas evaluables",
      "last_visit_id": "ID última visita",
      "last_visit_date": "Última visita",
      "last_visit_evaluable": "Última visita evaluable",
      "last_visit_score": "Nota última visita",
      "last_visit_max_band_name": "Semáforo última visita",
      "last_visit_max_band_color": "Color semáforo última visita",
      "pss_is_evaluated": "Evaluado en Tienda Perfecta",
      "pss_segment": "Tamaño (TP)",
      "pss_compliance": "Cumplimiento (TP)",
      "pss_sku_weight": "Peso SKU (TP)",
      "osa_score": "Nota Disponibilidad",
      "osa_earned": "Disponibilidad ganado",
      "osa_lost": "Disponibilidad perdido",
      "vis_status": "Visibilidad",
      "vis_reason": "Motivo sin medición",
      "vis_shelf_cm": "Anaquel (cm)",
      "vis_vale_cm": "Marca propia (cm)",
      "vis_participation": "Participación en anaquel",
      "vis_step1": "Visibilidad Paso 1",
      "vis_step2": "Visibilidad Paso 2",
      "vis_visit_score": "Nota visita (Visibilidad)",
      "vis_score": "Nota Visibilidad",
      "vis_earned": "Visibilidad ganado",
      "vis_lost": "Visibilidad perdido",
      "pss_partial": "PSS parcial",
      "pss_excluded_weight": "Peso sin medición",
      "vis_visits_no_measurement": "Visitas sin medición (Visibilidad)",
      "last_visit_osa_score": "Disponibilidad última visita",
      "last_visit_vis_score": "Visibilidad última visita",
      "last_visit_ceiling": "Techo última visita",
      "vis_compliance": "Cumplimiento Visibilidad (TP)",
      "tag_status": "Hablador",
      "tag_reason": "Motivo sin medición (Hablador)",
      "tag_skus_with_stock": "SKU con stock",
      "tag_skus_compliant": "SKU con preciador",
      "tag_score": "Nota Hablador",
      "tag_earned": "Hablador ganado",
      "tag_lost": "Hablador perdido",
      "list_status": "Precio lista",
      "list_reason": "Motivo sin medición (Precio lista)",
      "list_skus_compliant": "SKU en o bajo precio lista",
      "list_capture_warnings": "Precios a revisar",
      "list_score": "Nota Precio lista",
      "list_earned": "Precio lista ganado",
      "list_lost": "Precio lista perdido",
      "tag_visits_no_measurement": "Visitas sin medición (Hablador)",
      "list_visits_no_measurement": "Visitas sin medición (Precio lista)",
      "last_visit_tag_score": "Hablador última visita",
      "last_visit_list_score": "Precio lista última visita",
      "tag_compliance": "Cumplimiento Hablador (TP)",
      "tag_sku_weight": "Peso SKU Hablador (TP)",
      "tag_contribution": "Aporte Hablador (TP)",
      "list_price": "Precio lista",
      "list_compliance": "Cumplimiento Precio lista (TP)",
      "list_sku_weight": "Peso SKU Precio lista (TP)",
      "comp_status": "Competencia",
      "struct_status": "Estructura",
      "act_status": "Activación",
      "act_reason": "Motivo (Activación)",
      "act_skus_negotiated": "SKU negociados",
      "act_skus_compliant": "SKU con promoción ejecutada",
      "act_score": "Nota Activación",
      "act_earned": "Activación ganado",
      "act_lost": "Activación perdido",
      "act_visits_not_applicable": "Visitas sin negociación",
      "act_visits_no_measurement": "Visitas sin medición (Activación)",
      "last_visit_act_score": "Activación última visita",
      "pss_final": "PSS final",
      "final_band_name": "Semáforo final",
      "final_band_color": "Color semáforo final",
      "pss_evaluable_weight": "Puntos posibles",
      "last_visit_pss_final": "PSS final última visita",
      "last_visit_final_band_name": "Semáforo final última visita",
      "last_visit_final_band_color": "Color semáforo final última visita",
      "act_negotiated": "Negociado (TP)",
      "act_discount": "Descuento negociado (TP)",
      "act_target_price": "Precio de oferta máximo (TP)",
      "act_step1": "Hablador de oferta (TP)",
      "act_step2": "Precio de oferta (TP)",
      "act_compliance": "Cumplimiento Activación (TP)",
      "act_sku_weight": "Peso SKU Activación (TP)",
      "act_contribution": "Aporte Activación (TP)",
      "struct_reason": "Motivo sin medición (Estructura)",
      "struct_skus_compliant": "SKU con acomodo completo",
      "struct_score": "Nota Estructura",
      "struct_earned": "Estructura ganado",
      "struct_lost": "Estructura perdido",
      "struct_visits_no_measurement": "Visitas sin medición (Estructura)",
      "last_visit_struct_score": "Estructura última visita",
      "struct_compliance": "Cumplimiento Estructura (TP)",
      "struct_sku_weight": "Peso SKU Estructura (TP)",
      "struct_contribution": "Aporte Estructura (TP)",
      "comp_reason": "Motivo sin medición (Competencia)",
      "comp_capture_warnings": "Precios atípicos",
      "comp_score": "Nota Competencia",
      "comp_earned": "Competencia ganado",
      "comp_lost": "Competencia perdido",
      "comp_visits_no_measurement": "Visitas sin medición (Competencia)",
      "last_visit_comp_score": "Competencia última visita",
      "comp_role": "Rol (Competencia)",
      "comp_block": "Bloque (Competencia)",
      "comp_kg": "Kg",
      "comp_price_per_kg": "Precio por kilo ($/kg)",
      "comp_price_status": "Precio competencia",
      "comp_competitor_avg": "Promedio competencia ($/kg)",
      "comp_discount": "Descuento vs competencia",
      "comp_compliance": "Cumplimiento Competencia (TP)",
      "comp_sku_weight": "Peso SKU Competencia (TP)",
      "comp_contribution": "Aporte Competencia (TP)",
      "list_contribution": "Aporte Precio lista (TP)",
      "list_warning": "Aviso de precio (TP)",
      "vis_sku_weight": "Peso SKU Visibilidad (TP)",
      "vis_contribution": "Aporte Visibilidad (TP)",
      "pss_contribution": "Aporte al PSS (TP)"
    },
    "FILTER_LABELS": {
      "date_from": "Visita Final Desde",
      "date_to": "Visita Final Hasta",
      "marketer_name": "Mercaderista",
      "pos_name": "Punto de Venta",
      "chain_name": "Cadena",
      "region_name": "Región",
      "route_name": "Ruta",
      "product_name": "Producto",
      "product_sku": "SKU",
      "product_internal_code": "Código Interno",
      "category_name": "Categoría",
      "subcategory_name": "Subcategoría",
      "manufacturer_name": "Fabricante",
      "brand_name": "Marca",
      "unit_name": "Unidad",
      "packaging_type_name": "Tipo de Empaque",
      "availability": "Disponibilidad",
      "is_internal": "Producto Interno",
      "marketer_id": "ID Mercaderista",
      "pos_id": "ID Punto de Venta",
      "chain_id": "ID Cadena",
      "region_id": "ID Región",
      "route_id": "ID Ruta",
      "product_id": "ID Producto",
      "category_id": "ID Categoría",
      "subcategory_id": "ID Subcategoría",
      "manufacturer_id": "ID Fabricante",
      "brand_id": "ID Marca",
      "unit_id": "ID Unidad",
      "packaging_type_id": "ID Tipo Empaque"
    },
    "FILTER_GROUP": {
      "DATES": "Fechas",
      "VISIT": "Visita",
      "PRODUCT": "Producto",
      "STATUS": "Estado",
      "IDS": "IDs",
      "OTHER": "Otros"
    },
    "FROM": "Desde",
    "TO": "Hasta",
    "CLEAR_ALL": "Limpiar todo",
    "REMOVE_FILTER": "Quitar filtro {{filter}}",
    "FILTER_SEARCH": "Buscar filtros...",
    "ACTIVE_FILTERS": "Filtros activos",
    "SHOW_LESS": "Mostrar menos",
    "MORE_FILTERS": "Más filtros ({{count}})",
    "FILTER_ACTIVE": "filtro activo",
    "FILTERS_ACTIVE": "filtros activos",
    "FILTER_OPTIONS": {
      "availability": {
        "zero": "0 unidades",
        "low": "1-20 unidades",
        "high": "Más de 20 unidades"
      },
      "is_internal": {
        "true": "Sí",
        "false": "No"
      }
    },
    "AVAILABILITY_LEVELS": {
      "zero": "Sin stock",
      "low": "Stock bajo",
      "high": "Stock alto"
    }
  },
  "PAGINATION": {
    "SHOWING": "Mostrando {{start}}-{{end}} de {{total}} resultados"
  },
  "ROUTE": {
    "TITLE": "Rutas",
    "ACTIVE_HEADER": "Rutas activas",
    "NEW": "Nueva Ruta",
    "EDIT_TITLE": "Editar Ruta",
    "EMPTY_TITLE": "Sin rutas aún",
    "EMPTY_BODY": "Las rutas que crees aparecerán aquí.",
    "POS_COUNT": "{{count}} PDV",
    "NO_MARKETER": "Sin asignar",
    "UNASSIGNED": "Sin asignar",
    "ASSIGN_MARKETER": "Asignar Mercaderista",
    "UNASSIGN_MARKETER": "Desasignar",
    "MARKETER_AFTER_CREATE": "La asignación de mercaderista estará disponible después de crear la ruta.",
    "ADD_POS": "Agregar PDV",
    "DELETE_CONFIRM_BODY": "¿Estás seguro de eliminar {{name}}?",
    "FIELDS": {
      "NAME": "Nombre de la ruta",
      "MARKETER": "Mercaderista",
      "POS_ASSIGNMENTS": "Asignaciones de PDV",
      "VISIT_FREQUENCY": "Frecuencia de visita",
      "VISIT_DAYS": "Días de visita"
    },
    "DAYS": {
      "MON": "Lun",
      "TUE": "Mar",
      "WED": "Mié",
      "THU": "Jue",
      "FRI": "Vie",
      "SAT": "Sáb",
      "SUN": "Dom"
    },
    "ERRORS": {
      "POS_CONFLICT": "Conflicto de PDV: {{detail}}",
      "INVALID": "Datos inválidos: {{detail}}",
      "NOT_FOUND": "Ruta no encontrada."
    }
  },
  "SALES_POINT": {
    "TITLE": "Puntos de Venta",
    "POS": "Punto de Venta",
    "CHAINS": "Cadenas",
    "REGIONS": "Regiones",
    "EMPTY_POS": "No hay puntos de venta",
    "EMPTY_CHAINS": "No hay cadenas",
    "EMPTY_REGIONS": "No hay regiones",
    "NEW_POS": "Nuevo Punto de Venta",
    "EDIT_POS": "Editar Punto de Venta",
    "NEW_CHAIN": "Nueva Cadena",
    "EDIT_CHAIN": "Editar Cadena",
    "NEW_REGION": "Nueva Región",
    "EDIT_REGION": "Editar Región",
    "FORM": {
      "NAME": "Nombre",
      "CHAIN": "Cadena",
      "REGION": "Región",
      "ADDRESS": "Dirección"
    },
    "DUPLICATE_NAME": "Ya existe un registro con este nombre",
    "NOT_FOUND": "Registro no encontrado",
    "DELETE_ERROR_CHAIN": "No se puede eliminar: la cadena tiene puntos de venta asociados",
    "DELETE_ERROR_REGION": "No se puede eliminar: la región tiene puntos de venta asociados",
    "DELETE_ERROR_GENERIC": "No se puede eliminar este registro",
    "DOWNLOAD_TEMPLATE": "Descargar plantilla",
    "IMPORT": "Importar",
    "IMPORTING": "Importando puntos de venta...",
    "IMPORT_RESULT": "Importación completada. Total: {{total}} — Creados: {{created}} — Actualizados: {{updated}} — Errores: {{errors}}",
    "IMPORT_ERROR_ROW": "Fila {{row}}: {{message}}",
    "IMPORT_COMPLETED": "Importación finalizada",
    "IMPORT_DOWNLOAD_ERROR": "Error al descargar la plantilla. Intenta de nuevo.",
    "IMPORT_ERROR": "Error al importar los datos. Verifica el formato del archivo."
  },
  "SHIPPING": {
    "TITLE": "Entrega de productos",
    "EMPTY_TITLE": "Sin entregas pendientes",
    "EMPTY_BODY": "Las entregas de productos programadas aparecerán aquí."
  },
  "CHAIN": {
    "TITLE": "Cadenas",
    "NEW": "Nueva Cadena",
    "EDIT_TITLE": "Editar Cadena",
    "EMPTY_TITLE": "Aún no hay cadenas",
    "EMPTY_BODY": "Las cadenas que crees aparecerán aquí. Vincula productos a una cadena para que los mercaderistas los gestionen en los puntos de venta de la cadena.",
    "POS_COUNT": "{{count}} POS",
    "PRODUCT_COUNT": "{{count}} productos",
    "PRODUCTS_HINT": "El mercaderista solo verá y podrá elegir los productos vinculados a la cadena del punto de venta seleccionado durante una visita.",
    "ADD_PRODUCT": "Agregar producto",
    "DOWNLOAD_TEMPLATE": "Descargar plantilla",
    "IMPORT": "Importar",
    "IMPORT_RESULT": "Importación completada. Total: {{total}} — Creados: {{created}} — Actualizados: {{updated}} — Errores: {{errors}}",
    "IMPORT_RESULT_HEADER": "Importación finalizada",
    "IMPORT_ERROR_ROW": "Fila {{row}}: {{message}}",
    "IMPORT_ERROR": "Error al importar los datos. Verifica el formato del archivo.",
    "IMPORT_DOWNLOAD_ERROR": "Error al descargar la plantilla. Intenta de nuevo.",
    "DELETE_CONFIRM_BODY": "¿Seguro que deseas eliminar \"{{name}}\"?",
    "FIELDS": {
      "NAME": "Nombre de la cadena",
      "PRODUCTS": "Productos vinculados",
      "PRODUCT": "Producto",
      "PRODUCT_ASSIGNMENT": "Producto"
    },
    "ERRORS": {
      "POS_CONFLICT": "No se puede eliminar: {{detail}}",
      "INVALID": "Datos inválidos: {{detail}}",
      "NOT_FOUND": "Cadena no encontrada."
    },
    "NO_PRODUCTS": "Aún no hay productos vinculados.",
    "ADD_PRODUCTS": "Agregar productos",
    "ADD_SELECTED": "Agregar ({{count}})",
    "SEARCH_PRODUCTS": "Buscar productos...",
    "NO_MORE_PRODUCTS": "Todos los productos disponibles ya están vinculados a esta cadena.",
    "SELECT_ALL": "Seleccionar todo",
    "PAGINATION": "Página {{page}} de {{total}}"
  },
  "VISIT": {
    "TITLE": "Visita",
    "NEW_TITLE": "Nueva visita",
    "EDIT_TITLE": "Editar visita",
    "VIEW_TITLE": "Detalles de Visita",
    "VISIT": "Visita",
    "EMPTY_LIST": "Sin visitas. Toca + para crear una nueva.",
    "SYNC": "Sincronizar visitas",
    "SYNC_SUCCESS": "Visitas sincronizadas correctamente",
    "SYNC_PARTIAL": "Algunas visitas no pudieron sincronizarse",
    "SYNC_NONE": "No hay visitas pendientes por sincronizar",
    "SYNC_MANUAL": "Sincronizar ahora",
    "DELETE_TITLE": "Eliminar visita",
    "DELETE_MESSAGE": "Este borrador se eliminará permanentemente. Esta acción no se puede deshacer.",
    "DELETED": "Visita eliminada",
    "STATUS": {
      "DONE": "Completada",
      "IN_PROGRESS": "En progreso",
      "TO_UPLOAD": "Por sincronizar"
    },
    "TIMER": {
      "TOTAL": "tiempo total"
    },
    "TABS": {
      "ALL": "Todas",
      "IN_PROGRESS": "En progreso",
      "TO_UPLOAD": "Pendientes",
      "DONE": "Completadas"
    },
    "LIST": {
      "DURATION": "Duración",
      "SYNC_TIME": "Sincronización"
    },
    "TOUR": {
      "HELP": "Ver guía",
      "NEXT": "Siguiente",
      "PREV": "Atrás",
      "DONE": "Entendido",
      "ROUTE_TITLE": "Ruta y punto de venta",
      "ROUTE_TEXT": "Elige la ruta y luego el punto de venta que vas a visitar.",
      "START_TITLE": "Empezar la visita",
      "START_TEXT": "Cuando estés en el punto de venta, toca aquí. Desde ese momento todo se guarda solo.",
      "PRODUCTS_TITLE": "Agrega los productos",
      "PRODUCTS_TEXT": "Toca para buscar y elegir cada producto. Se abre su tarjeta para llenarla.",
      "PHOTO_TITLE": "Foto de anaquel",
      "PHOTO_TEXT": "Toma una foto del anaquel completo. Es obligatoria para cerrar la visita.",
      "SUBMIT_TITLE": "Completar la visita",
      "SUBMIT_TEXT": "Cuando todos los productos estén listos y tengas la foto, completa la visita. Después ya no se puede editar.",
      "SHELF_TITLE": "Medida del anaquel",
      "SHELF_TEXT": "Mide el anaquel una sola vez y anótalo aquí, en el primer producto. Vale para todos los productos de la visita.",
      "SEARCH_TITLE": "Buscar un producto",
      "SEARCH_TEXT": "Escribe el nombre o el código del producto que tienes enfrente.",
      "FILTER_TITLE": "Pendientes y registrados",
      "FILTER_TEXT": "«Pendientes» muestra lo que aún te falta registrar en este punto de venta; «Registrados», lo que ya llenaste.",
      "CATALOG_TITLE": "Elige el producto",
      "CATALOG_TEXT": "Toca un producto para abrir su tarjeta. El círculo amarillo indica que está incompleto y el check verde, que ya está registrado.",
      "AVAILABILITY_TITLE": "Disponibilidad",
      "AVAILABILITY_TEXT": "Cuenta las unidades en el anaquel y elige el rango. Si marcas Cero no se pide nada más de este producto.",
      "LINE_DONE_TITLE": "Terminar el producto",
      "LINE_DONE_TEXT": "Toca «Listo» para cerrar la tarjeta: si falta algo, te dice qué. «Eliminar» lo quita de la visita.",
      "VISIBILITY_TITLE": "Visibilidad",
      "VISIBILITY_TEXT": "Mide en centímetros el frente que ocupa este producto en el anaquel.",
      "PRICE_TITLE": "Precio",
      "PRICE_TEXT": "Indica si tiene preciador a la vista y anota el precio regular, con IVA y sin oferta.",
      "OFFER_TITLE": "Precio de oferta",
      "OFFER_TEXT": "Si ves un hablador de oferta, marca «Sí» y anota el precio de oferta.",
      "STRUCTURE_TITLE": "Acomodo",
      "STRUCTURE_TEXT": "Solo en productos de marca propia: responde cómo está acomodado. Debajo de cada pregunta se explica qué significa."
    },
    "FORM": {
      "SECTION_ROUTE": "Ruta y Punto de Venta",
      "SECTION_PRODUCTS": "Productos",
      "ROUTE": "Rutero",
      "SALES_POINT": "Punto de Venta",
      "PRODUCT": "Producto",
      "PRODUCTS": "productos",
      "AVAILABILITY_ZERO": "Cero (0 unds.)",
      "AVAILABILITY_LOW": "Bajo (1-20 unds.)",
      "AVAILABILITY_HIGH": "Alto (>20 unds.)",
      "NO_ROUTES": "Sin rutas asignadas. Sincroniza tus asignaciones.",
      "NO_POS_FOR_ROUTE": "Sin puntos de venta para esta ruta.",
      "SELECT_ROUTE_FIRST": "Selecciona una ruta primero",
      "SELECT_PRODUCT": "Seleccionar producto",
      "ALREADY_ADDED": "Agregado",
      "NO_PRODUCTS_YET": "Toca «Seleccionar producto» para registrar el primero.",
      "NO_PRODUCTS_FOUND": "Productos no encontrados",
      "CHAIN_PRODUCTS_HINT": "Productos de la cadena \"{{name}}\"",
      "NO_PRODUCTS_FOR_CHAIN": "No hay productos vinculados a esta cadena",
      "START_VISIT": "Empezar Visita",
      "VISIT_STARTED": "Visita iniciada",
      "START_HINT": "Selecciona ruta y punto de venta para empezar la visita",
      "SUBMIT": "Completar visita",
      "CONFIRM_SUBMIT_TITLE": "¿Completar la visita?",
      "CONFIRM_SUBMIT_MESSAGE": "Una vez completada, esta visita no se podrá editar. ¿Deseas finalizarla?",
      "SAVED_OFFLINE": "Guardado sin conexión — se sincronizará cuando haya internet",
      "SYNCED": "Visita sincronizada exitosamente",
      "SYNC_FAILED": "Error al sincronizar, se reintentará más tarde",
      "READ_ONLY": "Esta visita ya está completada",
 "VALIDATION_ERROR": "Completa todos los campos requeridos",
 "NO_PRODUCTS": "Agrega al menos un producto",
 "MISSING_AVAILABILITY": "Indica la disponibilidad de todos los productos",
 "MISSING_EVAL": "Completa la evaluación de \"{{product}}\"",
 "GENERAL_OBSERVATION": "Observación general (opcional)",
 "GENERAL_OBSERVATION_PLACEHOLDER": "Escribe aquí cualquier observación de la visita...",
 "SECTION_AVAILABILITY": "Disponibilidad",
 "SECTION_VISIBILITY": "Visibilidad",
 "SECTION_PRICE": "Precio",
 "SECTION_ACOMODO": "Acomodo",
 "SECTION_OBSERVATION": "Observación",
 "SECTION_PHOTO": "Foto de anaquel",
 "EVALUATION": "Evaluación",
 "SHELF_VISIBILITY_CM": "Anaquel (cm)",
 "SHELF_CM": "Anaquel de detergente (cm)",
 "SHELF_HINT": "Mide el anaquel una sola vez: vale para todos los productos de la visita.",
 "SHELF_EXCEEDED": "Los productos de marca propia suman {{own}} cm y el anaquel mide {{shelf}} cm. Revisa las medidas.",
 "MISSING_SHELF": "Falta la medida del anaquel",
 "PRODUCT_VISIBILITY_CM": "Producto (cm)",
 "HAS_PRICE": "¿Preciador visible?",
 "PRICE_HINT": "Con IVA y sin oferta",
 "MISSING_PRICE_TAG": "Indica si «{{product}}» tiene preciador visible",
 "YES": "Sí",
 "NO": "No",
 "PRICE": "Precio regular ($)",
 "HAS_DISCOUNT_PRICE": "Precio de oferta",
 "HAS_DISCOUNT_PRICE_HINT": "¿El producto tiene un hablador de oferta a la vista?",
 "MISSING_OFFER": "Indica si «{{product}}» tiene precio de oferta",
 "DISCOUNT_PRICE": "Oferta",
"IS_DIRECT_BLOCK": "Bloque directo",
"IS_DIRECT_BLOCK_HINT": "¿Los productos de la marca del mismo gramaje están juntos, formando un bloque, sin otras marcas entre ellos?",
"IS_SHELF_LEVEL_HINT": "¿Está en las 2 repisas principales, a la altura de los ojos de una persona promedio?",
"HAS_COMPETITOR_HINT": "¿Está al lado de la competencia líder (por ejemplo, Ariel o Las Llaves)?",
"MISSING_STRUCTURE": "Responde el acomodo de «{{product}}»",
  "IS_SHELF_LEVEL": "Nivel de plancha",
  "HAS_COMPETITOR": "Competencia al lado",
 "EVIDENCE_IMAGE": "Foto de evidencia del punto de venta",
 "EVIDENCE_HINT": "Toma una foto del punto de venta antes de finalizar",
 "EVIDENCE_ADD": "Tomar / subir foto",
 "EVIDENCE_CHANGE": "Cambiar foto",
 "EVIDENCE_REMOVE": "Quitar foto",
 "EVIDENCE_TITLE": "Evidencia",
      "CHAIN_PRODUCTS_REQUIRED_HINT": "Productos de la cadena \"{{name}}\": todos son obligatorios en la visita",
      "MISSING_AVAILABILITY_PRODUCT": "Indica la disponibilidad de \"{{product}}\"",
      "PRODUCT_FILTER_PENDING": "Pendientes",
      "PRODUCT_FILTER_DONE": "Registrados",
      "PRODUCT_FILTER_ALL": "Todos",
      "PRODUCT_STATUS_DONE": "Registrado",
      "PRODUCT_STATUS_INCOMPLETE": "Incompleto",
      "NO_PENDING_PRODUCTS": "No quedan productos pendientes",
      "LINE_DONE": "Listo",
      "REMOVE_PRODUCT": "Quitar",
      "REMOVE_PRODUCT_TITLE": "¿Quitar el producto?",
      "REMOVE_PRODUCT_MESSAGE": "Se borrarán los datos que registraste de «{{product}}».",
      "MISSING_PRODUCTS": "Productos de la cadena sin registrar: {{count}}",
      "RESUME_TITLE": "Visita en curso",
      "RESUME_MESSAGE": "Ya tienes una visita sin terminar en {{pos}}. ¿Quieres continuarla?",
      "RESUME_CONFIRM": "Continuar",
      "RESUME_NEW": "Empezar otra",
      "AUTOSAVE_SAVING": "Guardando…",
      "AUTOSAVE_SAVED": "Cambios guardados en el teléfono",
      "AUTOSAVE_ERROR": "No se pudo guardar. Se reintentará con el próximo cambio.",
      "SUMMARY_TITLE": "Visita completada",
      "SUMMARY_DURATION": "Duración: {{duration}}",
      "SUMMARY_PRODUCTS": "Productos registrados: {{count}} ({{stock}} con stock, {{zero}} sin stock)",
      "SUMMARY_SYNCED": "Enviada al servidor.",
      "SUMMARY_SYNC_FAILED": "No se pudo enviar; se reintentará automáticamente.",
      "SUMMARY_OFFLINE": "Sin conexión: se enviará cuando haya internet."
}
  },
  "SCANNER": {
    "TITLE": "Escáner"
  },
  "PERMISSIONS": {
    "TITLE": "Permisos",
    "STORAGE_SECTION": "Datos y almacenamiento",
    "CAMERA": "Cámara",
    "STORAGE_PERSISTENCE": "Almacenamiento persistente",
    "STORAGE_PERSISTENCE_DESC": "Evita la pérdida de datos locales bajo presión de almacenamiento",
    "STORAGE_LOCAL_DESC": "Los datos de la app se guardan localmente en este dispositivo. No se requiere permiso de almacenamiento externo.",
    "STORAGE_ESTIMATE_USED": "Usado: {{used}}",
    "STORAGE_ESTIMATE_AVAILABLE": "Disponible: {{available}}",
    "ESTIMATE_UNAVAILABLE": "Estimación de almacenamiento no disponible en este entorno",
    "STATUS": {
      "GRANTED": "Concedido",
      "PROMPT": "Pendiente",
      "DENIED": "Denegado",
      "PERMANENTLY_DENIED": "Bloqueado — abre ajustes del sistema para permitir",
      "UNAVAILABLE": "No disponible en este dispositivo"
    },
    "ACTIONS": {
      "REQUEST": "Solicitar permiso",
      "OPEN_SETTINGS": "Abrir configuración",
      "RETRY_PERSIST": "Reintentar almacenamiento persistente"
    },
    "CAMERA_RATIONALE_TITLE": "Acceso a cámara necesario",
    "CAMERA_RATIONALE_MESSAGE": "El escáner usa la cámara para leer códigos de barras. Esto te permite buscar productos rápidamente y completar inspecciones.",
    "CAMERA_DENIED_TITLE": "Permiso de cámara denegado",
    "CAMERA_DENIED_MESSAGE": "Se denegó el acceso a la cámara. Puedes cambiarlo cuando quieras desde los ajustes del dispositivo.",
    "CAMERA_BLOCKED_TITLE": "Acceso a cámara bloqueado",
    "CAMERA_BLOCKED_MESSAGE": "El permiso de cámara fue bloqueado permanentemente. Actívalo en los ajustes del dispositivo para usar el escáner.",
    "CAMERA_BLOCKED_PWA_MESSAGE": "El permiso de cámara fue bloqueado. Toca el candado en la barra de direcciones y permite el acceso a cámara para este sitio.",
    "CAMERA_DENIED_PWA_MESSAGE": "Se denegó el acceso a cámara. El escáner necesita acceso a la cámara para leer códigos de barras.",
    "PWA_SETTINGS_INSTRUCTIONS": "Ve a los ajustes de tu navegador o toca el candado en la barra de direcciones para gestionar los permisos del sitio.",
    "PERSIST_GRANTED": "Tus datos están protegidos contra eliminación automática",
    "PERSIST_DENIED": "Los datos locales podrían eliminarse bajo presión de almacenamiento. Intenta reactivar el almacenamiento persistente.",
    "PERSIST_UNAVAILABLE": "Almacenamiento persistente no disponible en este entorno (no aplica en modo nativo)"
  },
  "SELECTABLE": {
    "PRODUCT": "Producto",
    "PRODUCT_SELECTION": "Selección de producto",
    "NOT_FOUND_HEADER": "Producto por código de barras: \"{{code}}\" no encontrado.",
    "NOT_FOUND_MESSAGE": "No se encontró un producto con el código de barras escaneado. Intente la búsqueda con los otros métodos."
  },
  "SETTING": {
    "TITLE": "Configuración",
    "LOGOUT": "Salir",
    "PREFERENCES": "Ajustes",
    "DARK_MODE": {
      "TITLE": "Modo oscuro",
      "DESCRIPTION": "Cambia la apariencia de la aplicación"
    },
    "LANGUAGE": {
      "TITLE": "Idioma",
      "DESCRIPTION": "Elige el idioma de la aplicación"
    },
    "CONNECTIVITY": "Operaciones de comunicación",
    "DOWNLOAD_TIME": {
      "TITLE": "Tiempo de descarga",
      "DESCRIPTION": "Mide la velocidad de descarga",
      "RESULT": "Tiempo de descarga (1Mb / 125KB): petición {{requestMs}}ms ({{requestS}}s), descarga {{downloadMs}}ms ({{downloadS}}s)"
    },
    "UPLOAD_TIME": {
      "TITLE": "Tiempo de carga",
      "DESCRIPTION": "Mide la velocidad de subida"
    },
    "ACCOUNT": "Cuenta",
    "COLLECTIONS": {
      "TITLE": "Colecciones",
      "VIEW": "Ver colecciones",
      "VIEW_DESCRIPTION": "Explora los datos almacenados localmente",
      "ACTION_FOR": "Acción para: {{collection}}",
      "REMOVED": "La colección <{{collection}}> fue eliminada."
    },
    "UPDATE": {
      "TITLE": "Buscar actualizaciones",
      "DESCRIPTION": "Obtén la última versión de la aplicación"
    },
    "DELETE_ACCOUNT": {
      "TITLE": "Eliminar cuenta",
      "DESCRIPTION": "Esta acción no se puede deshacer",
      "CONFIRM_HEADER": "¿Eliminar cuenta?",
      "CONFIRM_MESSAGE": "Se eliminará tu sesión y todos los datos guardados localmente en este dispositivo. Esta acción no se puede deshacer.",
      "CONFIRM_OK": "Eliminar",
      "DONE": "Datos de la cuenta eliminados de este dispositivo"
    },
    "ADMINISTRATION": "Administración",
    "VERSION": "Versión",
    "INSTANCE": "Instancia"
  },
  "CHANGE_PASSWORD": {
    "TITLE": "Cambiar contraseña",
    "CURRENT": "Contraseña actual",
    "NEW": "Nueva contraseña",
    "CONFIRM": "Confirmar nueva contraseña",
    "HINT": "Mínimo 6 caracteres",
    "SUBMIT": "Cambiar contraseña",
    "NO_SESSION": "No se pudo identificar al usuario. Cierra sesión y vuelve a ingresar.",
    "SUCCESS": "Contraseña cambiada correctamente",
    "WRONG_CURRENT": "La contraseña actual no es correcta",
    "INVALID_DATA": "Datos inválidos. Verifica que la nueva contraseña tenga al menos 6 caracteres.",
    "SETTINGS_DESC": "Cambiar contraseña de un mercaderista",
    "MISMATCH": "Las contraseñas no coinciden"
  },
  "PSS": {
    "INDICATOR_AVAILABILITY": "Disponibilidad (OSA)",
    "INDICATOR_VISIBILITY": "Visibilidad (SOS)",
    "INDICATOR_PRICE_TAG": "Precio · Hablador",
    "INDICATOR_PRICE_LIST": "Precio · Lista",
    "INDICATOR_PRICE_COMPETITION": "Precio · Competencia",
    "INDICATOR_STRUCTURE": "Estructura · Acomodo",
    "INDICATOR_ACTIVATION": "Activación · Promoción",
    "FINAL": "PSS final",
    "FINAL_NOTE": "Promedio de tiendas, cada una con el promedio de sus visitas. Semáforo con la escala vigente.",
    "EVALUATED_OVER": "Evaluado sobre el {{weight}}: algún indicador no aplica o no se midió.",
    "POINTS_POSSIBLE": "Puntos posibles",
    "POINTS_EARNED": "{{earned}} ganados",
    "POINTS_EARNED_LABEL": "Puntos ganados / posibles",
    "EFFECTIVE_WEIGHT": "Peso efectivo",
    "ACT": {
      "NOT_APPLICABLE_SHORT": "No aplica",
      "REASON": {
        "no_negotiation": "La tienda no tenía una negociación de descuento vigente ese día: Activación ({{weight}}) sale del cálculo y la visita se evalúa sobre el resto.",
        "no_negotiated_skus": "La negociación vigente no incluye SKU del portafolio de la tienda: Activación ({{weight}}) sale del cálculo."
      },
      "REASON_SHORT": {
        "no_negotiation": "Sin negociación",
        "no_negotiated_skus": "Sin SKU negociados",
        "missing_offer": "Falta la oferta"
      },
      "STATUS": {
        "complete": "Medida",
        "no_measurement": "Sin medición",
        "not_applicable": "No aplica"
      },
      "COMPLIANT": "{{count}} de {{total}} SKU negociados con la promoción ejecutada",
      "DISCOUNT": "Descuento",
      "OFFER_TAG": "Hablador de oferta",
      "OFFER_VS_MAX": "Oferta / máximo",
      "OFFERS_NOT_NEGOTIATED": "{{count}} SKU con oferta sin negociación (informativo: no suma ni resta)."
    },
    "NEG": {
      "TITLE": "Negociaciones de descuento",
      "HINT": "Activación solo aplica en las visitas de tiendas con una negociación vigente ese día. Sin negociación, la tienda se evalúa sobre el 85 %. Cada negociación trae su vigencia: cargar una nueva no cambia las visitas fuera de ella.",
      "CHAIN": "Cadena",
      "ALL_CHAINS": "Todas las cadenas",
      "NEW": "Nueva negociación",
      "EDIT": "Editar negociación",
      "STORES": "Tiendas",
      "STORE": "Tienda",
      "PICK_STORES": "Elegir tiendas",
      "WHOLE_CHAIN": "Toda la cadena ({{count}} tiendas)",
      "SKU": "SKU",
      "ALL_SKUS": "Todos los SKU de marca propia",
      "DISCOUNT_PCT": "Descuento negociado (%)",
      "FROM": "Desde",
      "TO": "Hasta",
      "VALIDITY": "Del {{from}} al {{to}}",
      "EMPTY": "No hay negociaciones cargadas. Sin negociación, Activación no aplica.",
      "GROUP": {
        "current": "Vigentes",
        "upcoming": "Próximas",
        "past": "Vencidas"
      },
      "CREATED": "{{count}} negociación(es) creada(s)",
      "SAVED": "Negociación guardada",
      "DELETED": "Negociación eliminada",
      "DELETE_HEADER": "Eliminar negociación",
      "DELETE_MESSAGE": "¿Eliminar la negociación de «{{store}}»? Las visitas de su vigencia se recalculan.",
      "SAVE_ERROR": "No se pudo guardar la negociación",
      "ERR_STORES": "Elige al menos una tienda",
      "ERR_DISCOUNT": "El descuento debe ser mayor que 0 % y menor que 100 %",
      "ERR_DATES": "Faltan las fechas de vigencia",
      "ERR_DATE_ORDER": "«Hasta» no puede ser anterior a «Desde»"
    },
    "SECTION_STRUCTURE": "Estructura · Índice de Acomodo",
    "STRUCTURE_HINT": "Tres criterios por SKU con stock. El cumplimiento es la parte del peso de los criterios cuya respuesta es la que cumple (con el mismo peso: 0 %, 33 %, 67 % o 100 %).",
    "STRUCT_CRITERION": "Criterio",
    "STRUCT_ANSWER": "Cumple con",
    "STRUCT_WEIGHT": "Peso",
    "STRUCT_SHARE": "% del indicador",
    "STRUCT_CRITERIA_SHORT": {
      "direct_block": "Bloque",
      "shelf_level": "Nivel",
      "competitor": "Competencia"
    },
    "STRUCT_CRITERIA": {
      "direct_block": "Bloque directo",
      "shelf_level": "Nivel de plancha",
      "competitor": "Competencia al lado"
    },
    "STRUCT_CRITERIA_HINT": {
      "direct_block": "Los productos propios del mismo gramaje están juntos, formando un bloque de marca.",
      "shelf_level": "El producto está en las 2 repisas principales, a la altura de los ojos de una persona promedio.",
      "competitor": "El producto está al lado de la competencia líder (Ariel o Las Llaves)."
    },
    "ERR_STRUCTURE_WEIGHTS": "Los pesos de Estructura no pueden ser negativos y al menos uno debe ser mayor que 0",
    "STRUCT": {
      "COMPLIANT": "{{count}} de {{total}} SKU con stock cumplen los 3 criterios"
    },
    "SCORE_SHORT": "Nota",
    "SECTION_COMPETITION": "Precio competencia",
    "COMPETITION_HINT": "El precio por kilo de la marca propia se compara con el promedio por kilo de los competidores de su bloque de gramaje. Un precio de la competencia muy lejos de la mediana de la visita sale del promedio.",
    "COMP_RULE": "Regla de cumplimiento",
    "COMP_RULES": {
      "proportional": "Proporcional",
      "all_or_nothing": "Todo o nada"
    },
    "COMP_OUTLIER_PCT": "Precio atípico si se aleja más de (%) de la mediana",
    "COMP_BRANDS": "Marcas de la competencia",
    "COMP_BRAND": "Marca",
    "COMP_ROLE": "Rol",
    "COMP_ROLES": {
      "competitor": "Competidor (entra al promedio)",
      "tracking": "Seguimiento (solo se muestra)"
    },
    "COMP_PICK_BRAND": "Elegir marca",
    "COMP_ADD_BRAND": "Agregar marca",
    "COMP_BLOCKS": "Bloques de gramaje",
    "COMP_BLOCKS_HINT": "Cada tamaño compite con los gramajes de su bloque. Incluye los del propio tamaño con sus kilos: de ahí sale el precio por kilo.",
    "COMP_MIN_DISCOUNT_PCT": "Descuento mínimo (%)",
    "COMP_UNIT": "Gramaje",
    "COMP_KG": "Kg",
    "COMP_ADD_UNIT": "Agregar gramaje",
    "ERR_COMP_OUTLIER": "El umbral de precio atípico debe ser mayor que 0 %",
    "ERR_COMP_BRAND": "Cada marca de la competencia debe estar elegida y aparecer una sola vez",
    "ERR_MIN_DISCOUNT": "El descuento mínimo de cada tamaño debe ser mayor que 0 % y hasta 100 %",
    "ERR_BLOCK_KG": "Cada gramaje de un bloque necesita su unidad y sus kilos (mayor que 0)",
    "ERR_BLOCK_UNIT_TWICE": "Un gramaje solo puede estar en un bloque",
    "ERR_BLOCK_OWN_UNITS": "Cada bloque debe incluir los gramajes de su propio tamaño con sus kilos",
    "COMP": {
      "OUTLIERS": "{{count}} precio(s) de la competencia a más de {{pct}} de la mediana quedaron fuera del promedio: revisa la captura.",
      "OUTLIERS_SHORT": "Precios atípicos",
      "COMPLIANT": "{{count}} de {{total}} SKU con stock con el descuento mínimo",
      "BLOCK": "Bloque",
      "COMPETITION_KG": "Competencia ($/kg)",
      "OWN_KG": "Marca propia ($/kg)",
      "DISCOUNT": "Descuento",
      "TARGET": "Meta",
      "NOT_APPLICABLE": "Sin competencia en el bloque: no aplica y su peso pasa al otro bloque",
      "NOT_APPLICABLE_SHORT": "No aplica",
      "COMPETITOR": "Competencia levantada",
      "PER_KG": "$/kg",
      "STATUS": "Estado",
      "STATUSES": {
        "ok": "En el promedio",
        "outlier": "Revisar captura (atípico)",
        "tracking": "Seguimiento",
        "no_stock": "Sin stock",
        "no_price": "Sin precio"
      },
      "ROLE_LABEL": {
        "own": "Marca propia",
        "competitor": "Competidor",
        "tracking": "Seguimiento"
      },
      "GAP": "{{discount}} (meta {{target}})"
    },
    "INDICATOR_SHORT": {
      "availability": "Disponibilidad",
      "visibility": "Visibilidad",
      "price_tag": "Hablador",
      "activation": "Activación",
      "structure": "Estructura",
      "price_competition": "Competencia",
      "price_list": "Precio lista"
    },
    "SECTION_PRICE_BLOCK": "3. Precio",
    "SKUS_COUNT": "{{count}} SKU",
    "MEASUREMENT_REASON": {
      "missing_cm": "Falta el cm del anaquel o de algún producto con stock. Visibilidad no se cuenta en esta visita y el PSS se calcula sobre el resto.",
      "vale_exceeds_shelf": "Los cm de la marca propia superan el anaquel. Visibilidad no se cuenta en esta visita y el PSS se calcula sobre el resto.",
      "missing_price_tag": "Algún producto con stock no tiene respuesta en «¿Preciador visible?». Hablador no se cuenta en esta visita y el PSS se calcula sobre el resto.",
      "missing_offer": "Algún producto negociado con stock no tiene respuesta en «¿Precio de oferta?», o dice «Sí» sin el precio. Activación no se cuenta en esta visita y el PSS se calcula sobre el resto.",
      "missing_structure": "Algún producto propio con stock no tiene respuesta en el acomodo (bloque, nivel o competencia). Estructura no se cuenta en esta visita y el PSS se calcula sobre el resto.",
      "no_competition": "No hay precios válidos de la competencia en el anaquel. Competencia no se cuenta en esta visita y el PSS se calcula sobre el resto.",
      "missing_price": "Algún producto propio con stock no tiene precio. El indicador no se cuenta en esta visita y el PSS se calcula sobre el resto.",
      "no_list_price": "Falta el precio lista de algún tamaño en la Ponderación. Precio Lista no se cuenta en esta visita."
    },
    "MEASUREMENT_REASON_SHORT": {
      "missing_cm": "Faltan cm",
      "vale_exceeds_shelf": "Marca propia mayor que el anaquel",
      "missing_price_tag": "Falta «¿Preciador visible?»",
      "missing_offer": "Falta la oferta",
      "missing_structure": "Falta el acomodo",
      "no_competition": "Sin competencia en el anaquel",
      "missing_price": "Falta el precio",
      "no_list_price": "Sin precio lista"
    },
    "PRICE_WARNING": {
      "below_list": "Revisar captura",
      "above_list": "Sobre el precio lista"
    },
    "PRICE": {
      "TAG": "Preciador",
      "OBSERVED": "Precio",
      "LIST": "Precio lista",
      "GAP": "Diferencia",
      "VS_LIST": "Precio / lista",
      "TAG_CONTRIBUTION": "Aporte hablador",
      "LIST_CONTRIBUTION": "Aporte lista",
      "NO_ANSWER": "Sin respuesta",
      "YES": "Sí",
      "NO": "No",
      "REVIEW_CAPTURE": "Revisar captura",
      "TAG_COMPLIANT": "{{count}} de {{total}} SKU con stock tienen preciador",
      "LIST_COMPLIANT": "{{count}} de {{total}} SKU con stock en o bajo el precio lista",
      "CAPTURE_WARNINGS": "{{count}} SKU con precio más de {{pct}} por debajo del precio lista: revisa si se anotó bien. Cumplen igual."
    },
    "LIST_PRICE": "Precio lista ($)",
    "LIST_PRICE_HINT": "Precio lista: precio de venta sugerido al público del tamaño, en $ y con IVA. Para una lista nueva, crea una versión nueva con la fecha desde la que rige: así no cambian las visitas anteriores.",
    "SECTION_PRICE": "Precio",
    "PRICE_HINT": "Precio Lista cumple si el precio del anaquel está en o bajo el precio lista. Un precio muy por debajo cumple igual, pero se marca para revisar la captura.",
    "PRICE_WARNING_PCT": "Aviso «revisar captura» si está más de (%) por debajo",
    "ERR_LIST_PRICE": "Cada tamaño necesita un precio lista mayor que 0",
    "ERR_PRICE_WARNING": "El aviso de captura debe estar entre 0 % y 99 %",
    "WIDGET_SUBTITLE": "Los 7 indicadores y el semáforo final",
    "SKUS": {
      "SECTION": "Análisis por SKU",
      "SECTION_Q": "Cómo le va a cada producto, con su foto",
      "GALLERY_TITLE": "Productos",
      "GALLERY_Q": "Nota de cada SKU propio (lo que ganó sobre lo que podía ganar) y su cumplimiento por indicador. Toca uno para ver el detalle.",
      "LOST_POINTS": "Resta {{value}} pp al PSS",
      "CUMULATIVE": "Acumulado: {{value}} de lo perdido",
      "OWN": "Marca propia",
      "COMPETITION": "Competencia",
      "PER_KG": "Por kg",
      "CM": "Espacio",
      "CM_SHARE": "Parte del espacio propio",
      "IN_STOCK": "Con stock",
      "PARETO_TITLE": "¿Qué SKU nos cuesta más puntos?",
      "PARETO_Q": "Puntos del PSS final que pierde cada SKU, por indicador, de mayor a menor. A la derecha, cuánto del total perdido acumulan.",
      "NO_LOSSES": "Ningún SKU pierde puntos en el período.",
      "AVAILABILITY_TITLE": "Disponibilidad",
      "AVAILABILITY_Q": "Parte de las visitas con cada respuesta. Los que más faltan, arriba.",
      "AVAILABILITY": {
        "high": "Más de 20",
        "low": "1 a 20",
        "zero": "Sin stock",
        "unregistered": "Sin registro"
      },
      "PRICE_TITLE": "Precio",
      "PRICE_Q": "Rango de precios observados, promedio y precio lista de cada SKU propio.",
      "PRICE_KG_Q": "Precio por kilo de la marca propia y de la competencia, por tamaño.",
      "PRICE_UNIT": "Unitario",
      "PRICE_RANGE": "Rango",
      "PRICE_AVG": "Promedio",
      "PRICE_LIST": "Precio lista",
      "ABOVE_LIST": "Sobre el precio lista en el {{value}} de las visitas",
      "NO_PRICES": "No hay precios registrados en el período.",
      "SPACE_TITLE": "Espacio en anaquel",
      "SPACE_Q": "Centímetros promedio de cada SKU con stock, propios y de la competencia, por tamaño.",
      "LAST_PHOTO_TITLE": "Foto de la última visita",
      "LAST_PHOTO_Q": "Evidencia de una sola visita: la más reciente del filtro. No es el promedio.",
      "LAST_PHOTO_DATE": "Visita del",
      "LAST_PHOTO_STORE": "Tienda",
      "LAST_PHOTO_BY": "Mercaderista",
      "LAST_PHOTO_NOTE": "El PSS final y los puntos de al lado promedian todas las visitas del período; esta foto muestra solo cómo estaba el anaquel en esa visita, así que puede no coincidir con ellos.",
      "LAST_PHOTO_EMPTY": "Ninguna visita del período tiene foto de evidencia.",
      "LAST_PHOTO_ZOOM": "Toca para ampliar",
      "LAST_PHOTO_VIEWER": "Última visita · {{date}}",
      "OUT_OF_STOCK": "Sin stock o sin registro: {{value}}",
      "DETAIL_TITLE": "Detalle del SKU",
      "EARNED": "Ganado",
      "LOST": "Perdido",
      "BY_INDICATOR": "Por indicador",
      "SERIES_OWN": "Nota por día",
      "SERIES_COMP": "Precio por kilo por día",
      "CHAINS_OWN": "Nota por cadena",
      "CHAINS_COMP": "Precio por kilo por cadena",
      "STORES_OWN": "Tiendas donde peor le va",
      "STORES_COMP": "Tiendas con el precio por kilo más alto",
      "COL_STORE": "Tienda",
      "COL_SCORE": "Nota",
      "COL_LAST_AVAILABILITY": "Última disponibilidad",
      "COL_LAST_PRICE": "Último precio",
      "OPEN_VISIT": "Ver visita"
    },
    "DASH": {
      "FILTERS": "Filtros del dashboard",
      "FILTER_CHAIN": "Cadena",
      "FILTER_REGION": "Región",
      "ALL": "Todas",
      "KPI_STORES": "Tiendas evaluadas",
      "KPI_VISITS": "Visitas evaluables",
      "KPI_GREEN": "Tiendas en verde",
      "KPI_NEGOTIATIONS": "Negociaciones vigentes",
      "OF": "de {{total}}",
      "GREEN_HINT": "{{band}}: {{min}} % o más",
      "NEGOTIATIONS_NONE": "Activación no aplica",
      "NEGOTIATIONS_SOME": "Activación en juego",
      "NO_PREVIOUS": "Sin visitas en el período anterior: las flechas de comparación aparecen cuando las haya.",
      "SECTION_RESULT": "Resultado",
      "SECTION_RESULT_Q": "¿Cómo estamos y dónde se pierden los puntos?",
      "GAUGE_Q": "Promedio de tiendas, con el semáforo de la ficha",
      "CASCADE_TITLE": "De 100 puntos al PSS final",
      "GROUPS_OVERALL": "General {{value}}",
      "POINTS_TOTAL": "Ganado {{earned}} de {{possible}} posibles · PSS final {{final}}",
      "POINTS_WEIGHT": "peso {{weight}}",
      "POINTS_LOST": "Perdido",
      "POINTS_EARNED": "Ganado",
      "CASCADE_Q": "Cada barra mide el peso del indicador: lo ganado en su color, lo perdido en gris y lo que no aplica o no se midió, rayado.",
      "CASCADE_EXCLUDED": "Fuera del cálculo",
      "CASCADE_PENDING": "Pendiente",
      "CASCADE_READING_2": "Lo que más resta: {{first}} (−{{firstLoss}}) y {{second}} (−{{secondLoss}}).",
      "CASCADE_READING_1": "Lo que más resta: {{first}} (−{{firstLoss}}).",
      "CASCADE_EXCLUDED_NOTE": "Fuera del cálculo en alguna visita (sin medición o no aplica): {{names}}. En promedio, el PSS se evalúa sobre {{possible}} posibles.",
      "CASCADE_NOTE": "Los puntos son el promedio de las tiendas; el PSS final se calcula en cada tienda sobre sus puntos posibles.",
      "PROFILE_TITLE": "Perfil de indicadores",
      "PROFILE_Q": "Cumplimiento de cada indicador y su peso efectivo",
      "VIEW_BARS": "Barras",
      "VIEW_RADAR": "Radar",
      "EFFECTIVE_WEIGHT": "peso efectivo {{value}}",
      "WEIGHT_OUT": "peso {{value}} · fuera del cálculo",
      "POINTS_OF": "{{earned}} de {{weight}}",
      "NOT_APPLICABLE": "No aplica",
      "NO_MEASUREMENT": "Sin medición en el período",
      "NO_SCORE": "Sin nota",
      "OUT_OF_CALC": "fuera del cálculo",
      "RADAR_NOTE": "En el radar, un indicador que no aplica o sin medición se dibuja en 0. Las barras lo muestran aparte.",
      "HEATMAP_TITLE": "Productos × indicador",
      "HEATMAP_Q": "Qué producto falla y en qué (cumplimiento en %)",
      "HEATMAP_MISSING": "Sin columna por no tener medición en el período: {{names}}.",
      "ABBR": {
        "availability": "Disp.",
        "visibility": "Visib.",
        "price_tag": "Habl.",
        "price_list": "Lista",
        "price_competition": "Comp.",
        "activation": "Activ.",
        "structure": "Estr."
      },
      "SECTION_STORES": "Tiendas",
      "SECTION_STORES_Q": "Cómo se reparten las tiendas del período",
      "FEW_STORES": "Hay {{count}} tienda(s) con PSS final en el período: estos gráficos ganan sentido a medida que haya más visitas.",
      "DONUT_TITLE": "Tiendas por semáforo",
      "DONUT_Q": "Cuántas tiendas caen en cada tramo",
      "DONUT_CENTER": "tiendas",
      "RANKING_TITLE": "Ranking de tiendas",
      "RANKING_Q": "Toca una tienda para ver el desglose de su última visita",
      "WORST": "Peores",
      "BEST": "Mejores",
      "GROUPS_TITLE": "Comparativo",
      "GROUPS_Q": "Cómo se arma el PSS final de la cadena o región elegida: lo que suma cada indicador. La línea punteada es el PSS general.",
      "NO_NAME": "Sin nombre",
      "SECTION_TREND": "Comparativo y tendencia",
      "SECTION_TREND_Q": "Cómo se arma el PSS por cadena o región y cómo evoluciona en el tiempo",
      "TREND_TITLE": "PSS final por día",
      "TREND_Q": "Con los tramos del semáforo de fondo",
      "FEW_POINTS": "Hay un solo día con visitas en el período: la línea aparece desde el segundo.",
      "SPARKS_NOTE": "Nota de cada indicador por día. El número es el último día y la flecha lo compara con el día anterior con visitas.",
      "SECTION_DETAIL": "Detalle por indicador",
      "SECTION_DETAIL_Q": "Lo que cada indicador tiene de propio",
      "SCORE_FOOT": "Nota {{score}} · {{earned}} ganados",
      "VIS_Q": "Participación en el anaquel y reparto por tamaño",
      "COMP_Q": "Precio por kg de la marca propia contra el promedio de la competencia",
      "COMP_OWN": "Marca propia",
      "COMP_COMPETITION": "Competencia (promedio)",
      "COMP_MAX": "Precio máximo para cumplir",
      "COMP_NOTE": "La marca vertical es el precio máximo para cumplir el descuento mínimo del bloque.",
      "STRUCT_Q": "Productos con stock que cumplen cada criterio",
      "STRUCT_MET": "{{met}} de {{total}}",
      "ACT_Q": "Promoción negociada: hablador y precio de oferta",
      "ACT_MANAGE": "Negociaciones",
      "ACT_EMPTY_TITLE": "No hay negociaciones vigentes en el período",
      "ACT_EMPTY_BODY": "Activación no suma ni resta. Cuando se carguen negociaciones, aquí aparece el cumplimiento de cada producto negociado.",
      "MISSING_TITLE": "Qué falta medir",
      "MISSING_Q": "Visitas donde un indicador quedó sin medición o que no se pudieron evaluar",
      "MISSING_EMPTY": "Nada pendiente: las visitas del período midieron todo lo que aplicaba.",
      "NOT_EVALUABLE": "Visita no evaluable",
      "COL_CHAIN": "Cadena",
      "COL_INDICATOR": "Indicador",
      "COL_REASON": "Motivo",
      "COL_VISITS": "Visitas"
    },
    "PARTIAL": "PSS parcial",
    "PARTIAL_NOTE": "Suma de lo ganado en los indicadores ya implementados. El techo es lo máximo alcanzable si los pendientes salieran perfectos.",
    "EVALUABLE_NOTE": "Algún indicador no aplica o quedó sin medición en esta visita: se evalúa sobre el {{weight}} del PSS (los puntos posibles de la visita).",
    "VISITS_OF": "{{count}} de {{total}} visitas",
    "STEP_POINTS": "{{value}} pp del PSS",
    "SECTION_VISIBILITY": "Visibilidad",
    "VISIBILITY_HINT": "Paso 1: participación de la marca propia en el anaquel, contra la meta. Paso 2: reparto de ese espacio por tamaño, contra el mix ideal. El peso de Visibilidad se reparte entre los dos pasos.",
    "VIS_TARGET_PCT": "Meta de participación (%)",
    "VIS_STEP1_PCT": "Paso 1 · participación (%)",
    "VIS_STEP2_PCT": "Paso 2 · mix de tamaños (%)",
    "SPACE_TARGET_PCT": "Mix ideal (%)",
    "SPACE_TARGET_HINT": "Mix ideal: cómo debería repartirse el espacio de la marca propia entre tamaños (Paso 2 de Visibilidad). Cada tamaño necesita más de 0 % y deben sumar 100 %.",
    "ERR_SPACE_TARGET_ZERO": "Cada tamaño necesita un mix ideal mayor que 0 %",
    "ERR_SPACE_TARGET_SUM": "El mix ideal debe sumar 100 %",
    "ERR_VIS_TARGET": "La meta de participación debe ser mayor que 0 % y hasta 100 %",
    "ERR_VIS_STEP1": "El peso del Paso 1 debe estar entre 0 % y 100 %",
    "VIS": {
      "PARTICIPATION": "Participación en el anaquel",
      "TARGET": "meta {{value}}",
      "MIX": "Reparto del espacio por tamaño",
      "MIX_REAL": "Real",
      "MIX_IDEAL": "Ideal",
      "CM_CAPTION": "Marca propia: {{vale}} de {{shelf}} de anaquel",
      "STEP1": "Paso 1 · participación",
      "STEP2": "Paso 2 · mix",
      "NOT_APPLICABLE": "No aplica",
      "VISIT_SCORE": "Nota de la visita",
      "SCORE": "Nota Visibilidad",
      "CM": "cm",
      "CM_MISSING": "Falta",
      "NO_MEASUREMENT": "Sin medición",
      "NO_MEASUREMENT_SHORT": "Sin medición",
      "MISSING_INFO": "Falta información por reportar"
    },
    "VIS_STATUS": {
      "complete": "Medida",
      "no_measurement": "Sin medición"
    },
    "SCORE": "Nota Disponibilidad",
    "EARNED": "Ganado",
    "EARNED_OF": "Ganado (de {{weight}})",
    "LOSS": "Perdido",
    "CEILING": "Techo del PSS",
    "STORES": "Tiendas",
    "VISITS": "Visitas",
    "SKUS_REGISTERED": "SKU registrados",
    "SKUS_TITLE": "SKU por SKU",
    "SKU": "SKU",
    "SIZE": "Tamaño",
    "RECORDED": "Dato levantado",
    "COMPLIANCE": "Cumplimiento",
    "WEIGHT": "Peso",
    "CONTRIBUTION": "Aporte",
    "TOTAL": "Total",
    "NOT_REGISTERED": "Sin registro (cuenta como 0)",
    "AVAILABILITY": {
      "zero": "0 unidades",
      "low": "Entre 1 y 20 unidades",
      "high": "Más de 20 unidades"
    },
    "PATH_TITLE": "Camino al semáforo",
    "PENDING": "Pendiente",
    "FINAL_BAND": "Semáforo final",
    "FINAL_PENDING": "Pendiente: faltan {{count}} indicadores",
    "BREAKDOWN_TITLE": "Tienda Perfecta · Desglose de la visita",
    "CLOSE": "Cerrar",
    "LOAD_ERROR": "No se pudo cargar la información de Tienda Perfecta",
    "REASON": {
      "no_portfolio": "La cadena no tiene SKU propios asignados: la visita no se puede evaluar",
      "no_version": "La visita es anterior a la primera versión de la ponderación"
    },
    "NO_CHAIN": "Sin cadena",
    "NO_DATA": "No hay visitas evaluables en este período",
    "VISITS_COUNT": "{{count}} visita(s)",
    "STORES_COUNT": "{{count}} tienda(s)",
    "PERIOD_DAYS": "{{days}} días",
    "PERIOD_YEAR": "1 año",
    "SKU_CHART": "Cumplimiento por SKU",
    "TREND_CHART": "Nota por día",
    "STORE_WEIGHTED_NOTE": "Cada tienda pesa igual: promedio de sus visitas en el período.",
    "WEIGHTING": "Ponderación",
    "WEIGHTING_TITLE": "Tienda Perfecta",
    "TABS": {
      "WEIGHTING": "Ponderación",
      "NEGOTIATIONS": "Negociaciones"
    },
    "WEIGHTING_HINT": "Cada visita se evalúa con la versión vigente en su fecha. Para corregir una versión, edítala: sus visitas se recalculan. Para cambiar las reglas desde una fecha en adelante sin tocar el histórico, crea una versión nueva.",
    "VERSIONS": "Versiones",
    "NEW_VERSION": "Nueva versión",
    "NEW_VERSION_HINT": "Copia una versión existente con otra fecha de inicio. Después puedes editarla.",
    "BASE_VERSION": "Copiar de",
    "VERSION_NAME": "Nombre",
    "VALID_FROM": "Vigente desde",
    "CREATE": "Crear",
    "CURRENT": "Vigente",
    "VALIDITY": "Vigente del {{from}} al {{to}}",
    "OPEN_ENDED": "sin fecha de fin",
    "LAST_MODIFIED": "Modificada por {{user}} el {{date}}",
    "VERSION_CREATED": "Versión creada",
    "EDIT_VERSION": "Editar ponderación",
    "EDIT_IMPACT": "Esta versión evalúa {{count}} visitas: si la guardas, sus notas se recalculan.",
    "UNWEIGHTED_WARNING": "Estos SKU propios están asignados a cadenas pero su tamaño no tiene peso en esta versión, así que no se evalúan:",
    "SECTION_GENERAL": "General",
    "NOTES": "Notas",
    "SECTION_INDICATORS": "Peso de cada indicador",
    "INDICATORS_HINT": "Porcentaje del PSS que aporta cada indicador. Deben sumar 100 %. El semáforo final solo se calcula cuando los 7 están validados.",
    "INDICATOR": "Indicador",
    "WEIGHT_PCT": "Peso (%)",
    "VALIDATED": "Validado",
    "SUM": "Suma: {{value}} %",
    "SECTION_SEGMENTS": "Reparto por tamaño",
    "SEGMENTS_HINT": "Parte del peso que se lleva cada tamaño; dentro del tamaño se reparte en partes iguales entre sus SKU. Deben sumar 100 %.",
    "SHARE_PCT": "Reparto (%)",
    "UNITS": "Unidades del catálogo",
    "PICK_UNITS": "Elegir unidades",
    "ADD_SEGMENT": "Agregar tamaño",
    "REMOVE": "Quitar",
    "SECTION_SCORES": "Cumplimiento de Disponibilidad",
    "SCORES_HINT": "Cuánto vale cada respuesta del mercaderista (en %).",
    "SECTION_BANDS": "Escala del semáforo",
    "BANDS_HINT": "Cada tramo empieza en \"Desde (≥)\". El tramo más bajo debe empezar en 0 %.",
    "BAND_NAME": "Clasificación",
    "BAND_FROM": "Desde (≥ %)",
    "BAND_POINTS": "Puntos",
    "BAND_COLOR": "Color",
    "COLOR": {
      "green": "Verde",
      "yellow": "Amarillo",
      "orange": "Naranja",
      "red": "Rojo",
      "black": "Negro"
    },
    "ADD_BAND": "Agregar tramo",
    "SAVE": "Guardar",
    "SAVED": "Ponderación guardada",
    "SAVE_CONFIRM_HEADER": "¿Recalcular visitas?",
    "SAVE_CONFIRM_MESSAGE": "Esta versión evalúa {{count}} visitas. Al guardar, sus notas se recalculan con los nuevos valores.",
    "DELETE_VERSION": "Eliminar versión",
    "DELETED": "Versión eliminada",
    "DELETE_CONFIRM_HEADER": "Eliminar versión",
    "DELETE_CONFIRM_MESSAGE": "¿Eliminar la versión \"{{name}}\"? No tiene visitas asociadas.",
    "ERROR_HEADER": "Tienda Perfecta",
    "SAVE_ERROR": "No se pudo guardar la ponderación",
    "ERR_NAME": "Falta el nombre",
    "ERR_DATE": "Falta la fecha de inicio",
    "ERR_INDICATOR_SUM": "Los pesos de los indicadores deben sumar 100 %",
    "ERR_NO_SEGMENTS": "Define al menos un tamaño",
    "ERR_SEGMENT_SUM": "El reparto por tamaño debe sumar 100 %",
    "ERR_SEGMENT_NAME": "Cada tamaño necesita un nombre",
    "ERR_BAND_ZERO": "El tramo más bajo del semáforo debe empezar en 0 %",
    "ERR_SCORES": "Los puntajes deben ir de 0 a 100 y crecer con el stock",
    "REASON_SHORT": {
      "no_portfolio": "Cadena sin portafolio",
      "no_version": "Sin ponderación vigente"
    }
  }
}